/*
Copyright (c) 2012-2023 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { css } from "@emotion/core"

export const cardStyle = css`
  height: 100%;
  width: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  & > div {
    display: flex;
    flex-flow: column;
    height: 100%;
    .ant-card-head {
      margin-bottom: 0;
    }
    .ant-card-body {
      padding: 0px;
      flex-grow: 1;
      & > div {
        height: 100%;
      }
    }
  }
`

export const nonRoundRightCardStyle = css`
  border-top-right-radius: unset;
  border-bottom-right-radius: unset;
`

export const nonRoundLeftCardStyle = css`
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
`

export const headingStyle = css`
  font-size: 12px;
  text-transform: uppercase;
`

export const sortableContainerStyle = css`
  height: 100%;
`

export const gridStyle = css`
  background-color: #ffffff;
  border-bottom: 1px solid #ccd6dd;
  &:hover {
    .menuBtn {
      background-color: #f3f6fb;
    }
    background-color: #f3f6fb;
  }
`

export const tableCardStyle = css`
  .ant-card-head {
    padding: 0 20px;
  }
  .ant-card-head-title {
    padding: 17px 0;
  }
`
